import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink } from "@/types"
import OverheadFactor, { IOverheadFactorDto } from "./OverheadFactor"

export enum OverheadFactorsPhase {
    Sale = "Sale",
    Rental = 'Rental'
}

export interface IGetOverheadFactorsParams {
    assetCategoryId?: Guid
    divisionId?: Guid
}

export interface IOverheadFactorsDto {
    entities: IOverheadFactorDto[]
    links: IApiLink[]
}

export default class OverheadFactors {
    entities: OverheadFactor[]
    linkCreate?: IApiLink
    linkGetAssetTypes?: IApiLink
    linkGetAssetCategoriesAndDivisions?: IApiLink

    constructor(dto: IOverheadFactorsDto) {
        this.entities = dto.entities?.map(e => new OverheadFactor(e)) || []
        this.linkCreate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.overheadFactor && lnk.rel === ApiLinkRel.new)
        this.linkGetAssetTypes = dto.links.find(lnk => lnk.entity === ApiLinkEntity.assetType && lnk.rel === ApiLinkRel.all)
        this.linkGetAssetCategoriesAndDivisions = dto.links.find(lnk => lnk.entity === ApiLinkEntity.assetCategoriesAndDivisions && lnk.rel === ApiLinkRel.all)
    }
}
